module.exports = __webpack_public_path__ + "static/media/exotic.5ef7fc90.png";